// extracted by mini-css-extract-plugin
export default {"timeText":"DayNightAlerts_timeText__Rb2EH","icon":"DayNightAlerts_icon__j6XTB","graph":"DayNightAlerts_graph__LPLwg"};